// extracted by mini-css-extract-plugin
export default {"msgM":"e78085166e"};